import styled from 'styled-components';

export const ChipContainer = styled.span`
  display: inline-flex;
  align-items: center;
`;

export const ScoreChip = styled.span<{ $color: string; $filled?: boolean }>`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 2px 10px;
  border-radius: 12px;
  border: 1px solid ${({ $color }) => $color};
  color: ${({ theme, $color, $filled }) => ($filled ? theme.palette.common.white : $color)};
  background: ${({ theme, $color, $filled }) => ($filled ? $color : theme.palette.common.white)};
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  white-space: nowrap;
`;
